import { sb } from "../supabase.js";

const URLCACHE = {};

async function signedUrl(path) {
    const now = Date.now();
    if (URLCACHE[path] && URLCACHE[path].exp > now) return URLCACHE[path].url;
    const { data, error } = await sb.storage.from("estate-files").createSignedUrl(path, 3600);
    if (error) throw error;
    URLCACHE[path] = {
      url: data.signedUrl,
      exp: now + 3300 * 1000,
    };
    return data.signedUrl;
  }

export { URLCACHE, signedUrl };
